<template>
	<div class="hiq-article-list__items-wrapper">
    <ul class="hiq-article-list__items">
      <li
        class="hiq-article-list__items-item"
        data-link-box
        v-for="item in items"
        :key="item.url">
          <span class="hiq-article-list__items-item-banner"
            :style="'border-color:' + item.bannerColor.bgColor
              + '; background-color:' + item.bannerColor.bgColor
              + '; color:' + item.bannerColor.color"
            v-if="item.bannerText">
              {{ item.bannerText }}
          </span>
          <div class="hiq-article-list__items-item-image" :style="'background-image: url(' + item.imgUrl + ')'">
          </div>
          <div class="hiq-article-list__items-item-content">
            <div class="hiq-article-list__items-item-date" v-if="item.date" v-html="item.date"></div>
            <a 
              class="hiq-article-list__items-item-link"
              :href="item.url">
              <div class="hiq-article-list__items-item-title" v-if="item.title" v-html="item.title">
              </div>
            </a>
            <div class="hiq-article-list__items-item-desc" v-if="item.preamble" v-html="item.preamble"></div>
          </div>
        </li>
    </ul>
    <pulse-loader
      v-if="loading"
      :loading="loading"
      :color="'#006349'"
      aria-label="Laddar">
    </pulse-loader>
    <p class="hiq-article-list__items-text" v-if="total > 0 && !loading">
      Visar {{ items.length }} av {{ total }}
    </p>
    <button class="hiq-article-list__items-load-more" v-if="total > items.length && !loading" @click="loadMore">
			<span class="hiq-article-list__items-load-more--text">Visa fler</span>
    </button>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import { IItem, IState } from '../store/state';
import { search } from '../store/actions';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

interface IArticleItemsComputed {
  items: IItem[];
  loading: boolean;
  total: number;
  numberToShow: number
}

interface IArticleItemsMethods {
  loadMore(): void;
  focusFirstNewElement(index: number): void;
  updateItemLink(items:NodeListOf<HTMLElement>): void;
}

export default Vue.extend<{}, IArticleItemsMethods, IArticleItemsComputed, {}>({
	name: 'ArticleItems',
	computed: {
    items() {
      return this.$store.getters.items;
    },

    total() {
      return this.$store.getters.total;
    },
    
    loading() {
      return (this.$store.state as IState).loading;
    },

    numberToShow() {
      return this.$store.getters.numberToShow;
    }
	},

  methods: {
    loadMore() {
      let index = this.items.length;
      this.$store.commit({
        type: 'setNumberToShow',
        payload: Number(this.numberToShow) + Number(this.$store.state.initialNumberToShow)
      })
      this.$store.dispatch(search(''));
      this.focusFirstNewElement(index);
    },

    focusFirstNewElement(index: number){
      let links: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-article-list__items-item-link');
      let items: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-article-list__items-item');
      if(links[index]){
        links[index].focus();
      } else {
        setTimeout(() => { this.focusFirstNewElement(index) }, 100);
      }
      if(items) {
        this.updateItemLink(items);
      }
    },

    updateItemLink(items: NodeListOf<HTMLElement>) {
      items.forEach((item: any) => {
        const link:HTMLElement = item.querySelector('a');
        if (link) {
          item.style.cursor = 'pointer';
          const url = link.getAttribute('href') || '/';
          item.addEventListener('click', function () {
            window.location.href = url;
          });
        }
      })
    }
  },
  updated() {
    let items: NodeListOf<HTMLElement> = document.querySelectorAll('.hiq-article-list__items-item');
    if(items) {
      this.updateItemLink(items);
    }
  },
	components: {
    PulseLoader
	}
})
</script>
